module.exports = __webpack_public_path__ + "static/media/screenshot-2.d6577c44.png";